import type { UseIntl } from '../../../../types';
import { VALID_EMAIL_REGEX } from '../constants';
import messages from '../messages';

export const emailRegex = new RegExp(VALID_EMAIL_REGEX, 'i');

/**
 * It validates the email field value
 */
const validateEmail = (intl: UseIntl, value?: string): string => {
  let fieldError = '';

  const trimmedValue = (value ?? '').trim();

  if (!trimmedValue) {
    fieldError = intl.formatMessage(messages.validationEmailEmptyError);
  } else if (trimmedValue.length <= 2) {
    fieldError = intl.formatMessage(messages.validationEmailFormatError);
  } else if (!emailRegex.test(trimmedValue)) {
    fieldError = intl.formatMessage(messages.validationEmailFormatError);
  }
  return fieldError;
};

export default validateEmail;
